export default [
  {
    path: '/orders',
    component: () => import('@/views/orders/OrdersList.vue'),
    meta: { 
      title: 'Orders', 
      requiresAuth: true,
      requiresAmazon: true
    },
  },
  {
    path: '/orders/details/:id',
    component: () => import('@/views/orders/OrderDetails.vue'),
    meta: {
      title: 'Order', 
      requiresAuth: true,
      requiresAmazon: true
    },
  },
]